module.exports = __webpack_public_path__ + "img/O2.254629b2.png";